import { render, staticRenderFns } from "./ManualResearch.vue?vue&type=template&id=45730822&scoped=true&"
import script from "./ManualResearch.vue?vue&type=script&lang=js&"
export * from "./ManualResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45730822",
  null
  
)

export default component.exports